import {getCinema} from "../../api/features/cinema";

const state = () => ({

  cinema:{},
  newsId: null
})


const getters = {
  get_cinema(state) {
    return state.cinema;
  },
}

const mutations = {
  SET_CINEMA(state,data){
    state.cinema = data;}
}

const actions = {
  async fetchCinema({ commit }) {
    try {
      const response = await getCinema();
      commit('SET_CINEMA', response.data.results);
    } catch (error) {
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
